import { useTranslation } from "react-i18next";
import {DialogActions} from "../catalyst/dialog";
import {Button} from "../catalyst/button";
import Spinner from "../Spinner";

export default function ModalActions ({
    onClose,
    onSave,
    disableSave = false,
    disableCancel = false,
    saveLabel,
    closeLabel,
    isLoading = false
} : {
    onClose?: () => void,
    onSave?: () => void,
    saveLabel?: string,
    closeLabel?: string,
    isLoading?: boolean,
    disableSave?: boolean,
    disableCancel?: boolean
}) {

    const { t } = useTranslation()

    return (
        <DialogActions className={'px-4 pb-4'}>
            {
                (!disableSave) &&
                <Button plain onClick={() => {
                    if (isLoading) return
                    if (onClose) onClose()
                }}>
                    {isLoading && <Spinner color={'slate-700'} />}
                    {closeLabel || t('general.cancel')}
                </Button>
            }
            {
                (!disableCancel) &&
                <Button onClick={() => {
                    if (isLoading) return
                    if (onSave) onSave()
                }}>
                    {isLoading && <Spinner color={'white'} />}
                    {saveLabel || t('general.confirm')}
                </Button>
            }
        </DialogActions>
    )

}
